var map = {
	"./black/shangchuanchangjingtu2.png": "RBtV",
	"./blue/shangchuanchangjingtu2.png": "tWnX",
	"./white/shangchuanchangjingtu2.png": "mUem"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "V5Pb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/shangchuanchangjingtu2\.png$
// module id = V5Pb
// module chunks = 24